import { createClient } from '../../prismicio';

export function fetchPrismicSettings() {
  const client = createClient();
  return client.getSingle('settings');
}
